import axios from "axios"
import global from "../../globalvar";

async function getProductionStatFromTo(from, to, reduced=false ) {
    let reqbuilt = "/api/industrialdatalog/days/" + from + "/"+ to;
    if (reduced) reqbuilt += "/reduced"
    return (await axios.get(global.ApiBaseUrl +reqbuilt, {
        headers: {
            "x-auth-token": JSON.parse(localStorage.getItem("authInfo")).token
        }
    }))
}



export default {
    getProductionStatFromTo,
    
}